<template>

  <div>

    <v-content>

      <v-alert
        :value="alert"
        class="bold h4 alert"
        color="green"
        icon="new_releases"
        transition="scale-transition"
      >
        <v-layout row wrap class="align-center">
          <v-flex grow>
            Upozornění! Nacházíte se v Testovacím klientovi.
          </v-flex>
          <v-flex shrink>
            <v-btn color="white" :to="'/'" target="_blank" flat class="ma-0" small>Zpět</v-btn>
          </v-flex>
        </v-layout>
      </v-alert>
      <header :class="{'active': mobileMenu, 'alert-active': alert}">
        <v-container>
          <v-layout row wrap align-center justify-space-between v-if="isSigned && !loading">
            <eshop-link :to="{ path: '/' }">
              <v-layout row wrap align-center>
                <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="logo">
                <!-- <h1 class="h3">Comfort Commodity</h1> -->
              </v-layout>
            </eshop-link>
            <div class="actual-price">
              <p><strong>Aktuální cena</strong></p>
              <p class="inline-block">
                <strong>Zlato 1 oz: <span class="text-primary" v-if="cena_zlato!=null">{{cena_zlato | formatMoney}} Kč</span><span v-else>--</span></strong>
              </p>
              <p class="inline-block ml-3">
                <strong>Stříbro 1 kg: <span class="text-primary" v-if="cena_stribro!=null">{{cena_stribro | formatMoney}} Kč</span><span v-else>--</span></strong>
              </p>
            </div>
            <div class="menu mx-2">
              <eshop-link :to="{ path: '/eshop' }" class="inline-block text-xs-center ml-0 mr-3" :class="{'mr-4': $vuetify.breakpoint.lgAndUp}">
                <div><v-icon color="black">work_outline</v-icon></div>
                <span class="routes">E-SHOP</span>
              </eshop-link>
              <eshop-link :to="{ path: '/kosik' }" class="inline-block text-xs-center ml-2" :class="{'ml-4': $vuetify.breakpoint.lgAndUp}" v-if="kosik!=null">
                <div v-if="kosik.celkem > 0"><v-icon color="orange">shopping_cart</v-icon></div>
                <div v-else><v-icon color="black">shopping_cart</v-icon></div>
                <span class="routes">{{kosik.celkem | formatMoneyInt}} {{kosik.mena.zkratka}}</span>
              </eshop-link>
              <!-- <eshop-link :to="{ path: '/muj-ucet' }" class="inline-block text-xs-center ml-4 mr-0">
                <div><v-icon color="black">person_outline</v-icon></div>
                <span class="routes">{{me.cele_jmeno}}</span>
              </eshop-link> -->
            </div>
            <div class="signout-wrap py-1 pl-3 pr-1">
              <eshop-link :to="{ path: '/muj-ucet' }" class="inline-block text-xs-center">
                {{me.cele_jmeno}}
              </eshop-link>
              <div class="separator ml-2 mr-0"></div>
              <v-btn dark flat class="elevation-0 button button-signout ma-0" @click="signout">Odhlásit</v-btn>
            </div>
            <v-btn dark class="elevation-0 button button-mobile ma-0" @click="mobileMenu=true">Menu</v-btn>
            <nav role="navigation" class="mobile-menu">
              <v-layout row wrap class="tablet-menu__price">
                <v-flex grow>
                  <eshop-link :to="{ path: '/' }">
                    <v-layout row wrap align-center>
                      <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="logo">
                      <!-- <h1 class="h3">Comfort Commodity</h1> -->
                    </v-layout>
                  </eshop-link>
                </v-flex>
                <v-flex grow>
                  <div class="actual-price">
                    <p><strong>Aktuální cena</strong></p>
                    <p class="inline-block">
                      <strong>Zlato 1 oz: <span class="text-primary" v-if="cena_zlato!=null">{{cena_zlato | formatMoney}} Kč</span><span v-else>--</span></strong>
                    </p>
                    <p class="inline-block ml-3">
                      <strong>Stříbro 1 kg: <span class="text-primary" v-if="cena_stribro!=null">{{cena_stribro | formatMoney}} Kč</span><span v-else>--</span></strong>
                    </p>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="tablet-fix">
                <v-flex>
                  <ul @click="mobileMenu=false">
                    <li class="main link" v-if="(me.spolupracovnik && !alert && !me.podrizeny_maklere) || (me.makler && !alert)">
                      <router-link :to="{ path: '/spolupracovnici' }"><h3>Spolupracovníci</h3></router-link>
                    </li>
                    <li class="main title"><h3>Nákupy</h3></li>
                    <li class="submenu">
                      <router-link :to="{ path: '/jednorazove-nakupy' }"><span v-if="!alert">Jednorázové nákupy</span><span v-else>Jednorázové nákupy klienta</span></router-link>
                    </li>
                    <li class="submenu">
                      <router-link :to="{ path: '/postupne-nakupy' }"><span v-if="!alert">Postupné nákupy</span><span v-else>Postupné nákupy klienta</span></router-link>
                    </li>
                    <li class="submenu">
                      <router-link :to="{ path: '/moje-zbozi' }"><span v-if="!alert">Moje zboží</span><span v-else>Zboží klienta</span></router-link>
                    </li>
                    <li class="submenu">
                      <router-link :to="{ path: '/moje-faktury' }"><span v-if="!alert">Moje faktury</span><span v-else>Faktury klienta</span></router-link>
                    </li>
                    <li class="main link">
                      <router-link :to="{ path: '/penezenka' }"><h3>Peněženka</h3></router-link>
                    </li>
                  </ul>
                </v-flex>

                <v-flex>
                  <ul class="second" @click="mobileMenu=false">
                    <li class="main link" v-if="me.spolupracovnik && !alert">
                      <router-link :to="{ path: '/klienti' }"><h3>Klienti</h3></router-link>
                    </li>
                    <li v-if="me.spolupracovnik && !alert" class="main title"><h3>Obchody</h3></li>
                    <li v-if="me.spolupracovnik && !alert" class="submenu">
                      <router-link :to="{ path: '/obchody-a-provize' }"><span>Obchody a provize</span></router-link>
                    </li>
                    <li v-if="me.spolupracovnik && !alert && !me.podrizeny_maklere" class="submenu">
                      <router-link :to="{ path: '/pozice' }"><span>Pozice</span></router-link>
                    </li>
                    <li v-if="me.spolupracovnik && !alert && !me.podrizeny_maklere && !me.makler" class="submenu">
                      <router-link :to="{ path: '/nadrizeni-pracovnici' }"><span>Nadřízení pracovníci</span></router-link>
                    </li>
                    <li v-if="me.spolupracovnik && !alert" class="submenu">
                      <router-link :to="{ path: '/testovaci-klient' }"><span>Testovací klient</span></router-link>
                    </li>
                    <!-- <li class="main">
                      <router-link :to="{ path: '/udalosti' }" class="h3">Události <span class="menu-number__counter">12</span></router-link>
                    </li> -->
                    <li v-if="!alert && !me.podrizeny_maklere && !me.makler" class="main link">
                      <router-link :to="{ path: '/ke-stazeni' }"><h3>Ke stažení</h3></router-link>
                    </li>
                    <li v-if="!alert" class="main link">
                      <router-link :to="{ path: '/kontakty' }"><h3>Kontakty</h3></router-link>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>

              <p class="mb-0 text-xs-center">
                <div class="text-xs-center">
                  <v-btn dark color="orange" class="elevation-0 bold mx-0 mt-5" @click="mobileMenu=false">Zavřít menu</v-btn>
                </div>
                <div class="text-xs-center">
                  <v-btn dark class="elevation-0 button button-signout button-mobile-show mx-0 mt-3 mb-4" @click="signout">Odhlásit</v-btn>
                </div>
              </p>
            </nav>
          </v-layout>
          <v-layout row wrap v-if="isSigned && !loading">
            <v-flex xs12>
              <ul class="navigation" :class="{'alert-menu__active': alert, 'client-nav': !me.spolupracovnik}">
                <li>
                  <eshop-link :to="{ path: '/' }" class="button button-home"><v-icon color="white">home</v-icon></eshop-link>
                </li>
                <!-- <li>
                  <eshop-link :to="{ path: '/eshop' }">E-shop</eshop-link>
                </li> -->
                <li v-if="alert">
                  <eshop-link :to="{ path: '/muj-ucet' }"><span>Údaje o klientovi</span></eshop-link>
                </li>
                <li v-if="(me.spolupracovnik && !me.podrizeny_maklere) || (me.makler)">
                  <eshop-link :to="{ path: '/spolupracovnici' }">Spolupracovníci</eshop-link>
                </li>
                <li>
                  <v-menu offset-y>
                    <span slot="activator"><span>Nákupy</span> <v-icon small class="ml-2" color="black">keyboard_arrow_down</v-icon></span>
                    <v-list dense class="menu-list">
                      <v-list-tile>
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/jednorazove-nakupy' }"><span v-if="!alert">Jednorázové nákupy</span><span v-else>Jednorázové nákupy klienta</span></eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/postupne-nakupy' }"><span v-if="!alert">Postupné nákupy</span><span v-else>Postupné nákupy klienta</span></eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/moje-zbozi' }"><span v-if="!alert">Moje zboží</span><span v-else>Zboží klienta</span></eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/moje-faktury' }"><span v-if="!alert">Moje faktury</span><span v-else>Faktury klienta</span></eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </li>
                <li>
                  <eshop-link :to="{ path: '/penezenka' }">Peněženka</eshop-link>
                </li>
                <li v-if="!me.spolupracovnikf">
                  <eshop-link :to="{ path: '/kontakty' }">Kontakty</eshop-link>
                </li>
                <li v-if="me.spolupracovnik">
                  <eshop-link :to="{ path: '/klienti' }">Klienti</eshop-link>
                </li>
                <li v-if="(me.spolupracovnik || me.tipar) && !alert">
                  <v-menu offset-y>
                    <span slot="activator"><span>Obchody</span> <v-icon small class="ml-2" color="black">keyboard_arrow_down</v-icon></span>
                    <v-list dense class="menu-list">
                      <v-list-tile>
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/obchody-a-provize' }">Obchody a provize</eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="me.spolupracovnik && !alert && (!me.podrizeny_maklere || me.makler)">
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/pozice' }">Pozice</eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="me.spolupracovnik && !alert && !me.podrizeny_maklere && !me.makler">
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/nadrizeni-pracovnici' }">Nadřízení pracovníci</eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="me.spolupracovnik && !alert">
                        <v-list-tile-title>
                          <eshop-link :to="{ path: '/testovaci-klient' }" target="_blank">Testovací klient</eshop-link>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </li>
                <!-- <li>
                  <eshop-link :to="{ path: '/udalosti' }">Události <span class="menu-number__counter">12</span></eshop-link>
                </li> -->
                <li v-if="!alert && !me.podrizeny_maklere && !me.makler">
                  <eshop-link :to="{ path: '/ke-stazeni' }">Ke stažení</eshop-link>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-container>
      </header>
      <router-view :class="{'body-hidden': mobileMenu}"/>

    </v-content>
    <v-bottom-nav
      :active.sync="bottomNav"
      :value="true"
      fixed
      color="white"
      class="bottom-nav"
      v-if="isSigned && !loading"
    >
      <v-btn
        color="orange"
        flat
        value="dashboard"
        :to="{path: '/muj-ucet'}"
      >
        <span class="bold">{{me.cele_jmeno}}</span>
        <v-icon>person_outline</v-icon>
      </v-btn>

      <v-btn
        color="orange"
        flat
        value="eshop"
        :to="{path: '/eshop'}"
      >
        <span class="bold">e-shop</span>
        <v-icon>work_outline</v-icon>
      </v-btn>

      <v-btn
        color="orange"
        flat
        value="basket"
        :to="{path: '/kosik'}"
      >
        <span class="bold">{{kosik.celkem | formatMoneyInt}} {{kosik.mena.zkratka}}</span>
        <div v-if="kosik.celkem > 0"><v-icon color="orange">shopping_cart</v-icon></div>
        <div v-else><v-icon color="black">shopping_cart</v-icon></div>
      </v-btn>
    </v-bottom-nav>

  </div>

</template>

<script>

import Login from '@/components/Login'

export default {
  name: 'App',
  data () {
    return {
      bottomNav: 'eshop',
      mobileMenu: false,
      isSigned: false,
      loading: false,
      kosik: null,
      alert: false,
      cena_zlato: null,
      cena_stribro: null,
      interval: null
    };
  },
  computed: {
    me: function() {
      return window.$me;
    }
  },
  watch: {
    $route (to, from){
      window.API.get("nastenka/komodity").then(function(body) {
        this.cena_zlato = body.zlato;
        this.cena_stribro = body.stribro;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      window.API.get("nastenka/komodity").then(function(body) {
        this.cena_zlato = body.zlato;
        this.cena_stribro = body.stribro;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }, 120000);
    this.alert = window.testovaci_klient;
    this.$nextTick(function () {
      this.check();
    }.bind(this));
    window.Kosik.listen(() => {
      this.loadKosik();
    });
    window.API.get("nastenka/komodity").then(function(body) {
      this.cena_zlato = body.zlato;
      this.cena_stribro = body.stribro;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    check: function() {
      this.loading = true;
      window.API.get("uzivatel").then(function(body) {
        window.$me = body;
        window.$user = body;
        this.$data.isSigned = typeof body.prihlasen !== "undefined" && body.prihlasen;
        this.loadKosik(() => {
          this.loading = false;
        });
      }.bind(this)).catch(function(err) {
          this.$data.isSigned = false;
          this.loading = false;
          console.log(err);
      }.bind(this));
    },
    loadKosik (f) {
      window.API.get("kosik").then(function(body) {
        this.kosik = body;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        if (typeof f == "function")
          f();
      }.bind(this));
    },
    signout: function() {
      window.API.$setCookie("cc_eshop_uid", "", { expires: -30, path: "/" });
      window.API.$setCookie("cc_eshop_token", "", { expires: -30, path: "/" });
      window.location.reload();
    }
  },
  components: {
    Login
  }
}
</script>
